const initialUser = () => {
  const token = window.localStorage.getItem('aygi_auth_token');
  return { authorized: !!token };
};

export default initialUser;
